import { ActionIcon, type ActionIconProps, Menu } from "@mantine/core"
import type { PropsWithChildren } from "react"
import { icons, StopPropagation } from "../utils"

export function ActionsMenu({ children, ...props }: PropsWithChildren<ActionIconProps>) {
  return (
    <StopPropagation>
      <Menu shadow="md">
        <Menu.Target>
          <ActionIcon size="lg" radius="lg" variant="subtle" color="dark" {...props}>
            <icons.Menu size="1.5rem" />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>{children}</Menu.Dropdown>
      </Menu>
    </StopPropagation>
  )
}
